<template>
	<ion-page>
		<spot-header :title="pageTitle" :canLogOut="tablesData.currentWarehouse && isActive && settings.home.lockPlantAndWarehouse" @pressedLogOut="executeLogOut"></spot-header>
		<ion-content :fullscreen="true">
			<web-socket-barcode @scanned="onScan" v-if="isActive"></web-socket-barcode>
			<ion-item v-if="updatingLibraries || searchingData"> <!-- v-if="!isActive" -->
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="tablesData.plants.length > 0"> <!-- v-else -->
				<spot-select
					:ref="plantField.name"
					:label="plantField.text"
					:allignLabel="plantField.allignLabel"
					:required="plantField.required"
					:placeholder="getPlaceHolder(plantField)"
					:enabled="!(tablesData.currentPlant && tablesData.currentWarehouse) || !settings.home.lockPlantAndWarehouse"
					:value="plantField.value"
					:options="tablesData.plants"
					:optionField="plantField.refField"
					:canAddItem="plantField.canAddItem"
					:canRefreshList="plantField.canRefresh"
					:canUnlock="plantField.canUnlock"
					selectedLabel="Selezionato"
					deselectLabel="rimuovi"
					selectLabel="seleziona"
					@selected="detectSelection(plantField, $event)"
					@unselected="detectUnselection(plantField)">
				</spot-select>
				<spot-select
					:ref="warehouseField.name"
					:label="warehouseField.text"
					:allignLabel="warehouseField.allignLabel"
					:required="warehouseField.required"
					:placeholder="getPlaceHolder(warehouseField)"
					:enabled="plantField.value && (!(tablesData.currentPlant && tablesData.currentWarehouse) || !settings.home.lockPlantAndWarehouse)"
					:value="warehouseField.value"
					:options="tablesData.warehouses"
					:optionField="warehouseField.refField"
					:canAddItem="warehouseField.canAddItem"
					:canRefreshList="warehouseField.canRefresh"
					:canUnlock="warehouseField.canUnlock"
					selectedLabel="Selezionato"
					deselectLabel="rimuovi"
					selectLabel="seleziona"
					@selected="detectSelection(warehouseField, $event)"
					@unselected="detectUnselection(warehouseField)">
				</spot-select>
				<div class="search-container" v-if="tablesData.currentWarehouse && !updatingLibraries">
					<ion-item class="input-form no-pad">
						<spot-button size="small" color="primary" icon="locationSharp" :enabled="false" :expand="null" :text="null">
						</spot-button>
						<ion-input name="bPosition" id="bPosition" type="text" :placeholder="barcodePositionText" v-model="positionBarcode" v-on:keyup.enter="positionSearch"></ion-input> <!--@keypress.enter="onScan()"-->
					</ion-item>
					<ion-item class="input-form no-pad">
						<spot-button size="small" color="primary" icon="searchOutline" :enabled="false" :expand="null" :text="null">
						</spot-button>
						<ion-input name="bPackage" id="bPackage" type="text" :placeholder="barcodePackageText" v-model="packageBarcode" v-on:keyup.enter="packageSearch"></ion-input> <!--@keypress.enter="onScan()"-->
					</ion-item>
					<ion-item class="input-form no-pad">
						<spot-button size="small" color="primary" icon="librarySharp" :enabled="false" :expand="null" :text="null">
						</spot-button>
						<ion-input name="bItemsLocation" id="bItemsLocation" type="text" :placeholder="barcodeItemsLocationText" v-model="itemsLocationBarcode" v-on:keyup.enter="itemsLocationSearch"></ion-input> <!--@keypress.enter="onScan()"-->
					</ion-item>
				</div>
				<div class="actions-container" v-if="tablesData.currentWarehouse && !updatingLibraries">
					<router-link :to="`/insert`">
						<div><ion-icon class="action-icons" :icon="create"></ion-icon></div>
						<div><ion-label>{{ newActivityText }}</ion-label></div>
					</router-link>
					<router-link :to="`/insert/multiple`">
						<div><ion-icon class="action-icons" :icon="layers"></ion-icon></div>
						<div><ion-label>{{ newMultipleText }}</ion-label></div>
					</router-link>
				</div>
				<div class="actions-container" v-if="tablesData.currentWarehouse && !updatingLibraries">
					<router-link :to="`/search`"> <!-- :to="`/search?direction=shipments/deliveries`"-->
						<div><ion-icon class="action-icons" :icon="archive"></ion-icon></div>
						<div><ion-label>{{ oldActivityText }}</ion-label></div>
					</router-link>
					<router-link :to="`/search?disposable=true`" v-if="isDisposeAllowed">
						<div><ion-icon class="action-icons" :icon="trash"></ion-icon></div>
						<div><ion-label>{{ disposeItemsText }}</ion-label></div>
					</router-link>
					<!--
					<button color="primary" @click="getAllTablesData">
						<div><ion-icon class="action-icons" :icon="server" color="primary"></ion-icon></div>
						<div><ion-label>{{ updateLibrariesText }}</ion-label></div>
					</button>
					-->
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	.search-container {
		/*margin-top: 1em;*/
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.input-form {
		font-size: 3vh;
		text-align: left;
		display: flex;
		flex-direction: row;
		justify-content: left;
		align-items: center;
		/*margin-top: 0.5em;*/
	}
	.actions-container {
		/*margin-top: 2em;*/
		text-align: center;
		border-radius: 5em !important;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.action-icons {
		font-size: 128px;
		margin-left: .2em;
		margin-right: .2em;
	}
	.no-pad {
		margin-top: 0px;
		margin-bottom: 0px;
		padding-top: 0px;
		padding-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	router-link {
		display: flex;
		flex-direction: column;
	}
	ion-label {
		color: var(--ion-color-medium);
	}
</style>

<script>
	import WebSocketBarcode from "@/components/WebSocketBarcode.vue";
	import { feName } from "@/plugins/variables.js";
	import { IonContent, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonSpinner } from '@ionic/vue';
	import { archive, create, layers, locationSharp, librarySharp, searchOutline, /*server,*/ trash } from "ionicons/icons";
	import { defineComponent } from 'vue';
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotSelect from "../components/SpotSelect.vue";
	import { checkAdmin, confirmYesNo, showMsgError, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { getPlant, getPlants, getPrinter, getRawAddressees, getRawAlternativeAddressees,getRawCarriers, getRawEmployees, getRawItems, getRawSuppliers, getSettings, hasPrinter, searchLocation, searchLocations, searchProject, searchProjectRow, searchProjectRows, searchWarehouses, tablesData, updateUser } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: 'HomePage',
		props: {
			pageTitle: { type: String, default: "Benvenuto in " + feName },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			checkPrintersText: { type: String, default: "Controllo Stampanti..." },
			loadingEnabledPrinterText: { type: String, default: "Caricamento Stampante Abilitata..." },
			loadingPlantsText: { type: String, default: "Caricamento Stabilimenti..." },
			loadingWarehousesText: { type: String, default: "Caricamento Magazzini..." },
			loadingLocationText: { type: String, default: "Caricamento Ubicazione..." },
			loadingLocationsText: { type: String, default: "Caricamento Ubicazioni..." },
			loadingProjectText: { type: String, default: "Caricamento Testata..." },
			loadingProjectRowText: { type: String, default: "Caricamento Dettaglio..." },
			loadingProjectRowsText: { type: String, default: "Caricamento Dettagli..." },
			loadingCarriersText: { type: String, default: "Caricamento Corrieri..." },
			loadingSuppliersText: { type: String, default: "Caricamento Fornitori..." },
			loadingItemsText: { type: String, default: "Caricamento Formati..." },
			loadingAddresseesText: { type: String, default: "Caricamento Destinatari..." },
			loadingAlternativeAddresseesText: { type: String, default: "Caricamento Destinatari Alternativi..." },
			loadingEmployeesText: { type: String, default: "Caricamento Dipendenti..." },
			barcodePositionText: { type: String, default: "Trova ubicazione articolo" },
			barcodePackageText: { type: String, default: "Ricerca tramite barcode" },
			barcodeItemsLocationText: { type: String, default: "Vedi contenuto ubicazione" },
			newActivityText: { type: String, default: "Nuova registrazione" },
			newMultipleText: { type: String, default: "Consegne/Ritiri multipli" },
			oldActivityText: { type: String, default: "Archivio registrazioni" },
			disposeItemsText: { type: String, default: "Smaltisci registrazioni" },
			updateLibrariesText: { type: String, default: "Aggiorna anagrafiche" },
			searchTitle: { type: String, default: "Ricerca Spedizione/Ricezione" },
			nullBarcode: { type: String, default: "Non è stato inserito alcun barcode da cercare" },
			invalidProjectMsg: { type: String, default: "Barcode trovato, ma esterno a " + feName },
			differentPlantOrWarehousetMsg: { type: String, default: "Articolo presente, ma in Stabilimento o Magazzino diverso da quello impostato" },
			foundPosition: { type: String, default: "La posizione dell'articolo è la seguente: " },
			notFoundPosition: { type: String, default: "Articolo esistente, ma la posizione non era stata inserita!" },
			notFoundPackageMsg: { type: String, default: "Nessun pacco trovato, corrispondente al barcode inserito!" },
			notFoundLocationMsg: { type: String, default: "Nessun pacco trovato nell'ubicazione, corrispondente al barcode inserito!<br>Oppure il barcode inserito non rappresenta una ubicazione esistente!" },
			notFoundLocation: { type: String, default: "L'ubicazione inserita, non esiste!" },
			differentWarehousetMsg: { type: String, default: "L'ubicazione inserita, è in un Magazzino diverso da quello impostato" },
			unselectedChoice: { type: String, default: "Occorre selezionare il campo di input, prima di leggere il barcode!" },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			warningPrintNotFound: { type: String, default: "Attenzione, questo magazzino non ha una stampante assegnata (le etichette non verranno stampate)!" },
			messageTitlePlantWarehouse: { type: String, default: "Stabilimento - Magazzino" },
			messageConfirm: { type: String, default: "Confermi " },
		},
		components: {
			IonPage,
			IonContent,
			IonSpinner,
			IonItem,
			IonIcon,
			IonInput,
			IonLabel,
			SpotHeader,
			SpotButton,
			SpotSelect,
			WebSocketBarcode,
		},
		data: () => ({
			isActive: null,
			spinnerText: null,
			field: {
				plant: 0,
				warehouse: 1,
			},
			fields: [
				{ id: 0, name: 'plant', text: 'Stabilimento', allignLabel: true, placeholder: 'Seleziona Stabilimento', refTable: 'plants', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'name', canAddItem: false, canRefresh: false, canUnlock: false, },
				{ id: 1, name: 'warehouse', text: 'Magazzino', allignLabel: true, placeholder: 'Seleziona Magazzino', refTable: 'warehouses', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'name', canAddItem: false, canRefresh: false, canUnlock: false, },
			],
			isFromLogin: null,
			positionBarcode: null,
			packageBarcode: null,
			itemsLocationBarcode: null,
			plantAutoAssignment: null,
			updateUserWhenPlantChange: null,
			updatingLibraries: null,
			searchingData: null,
			locationSharp,
			searchOutline,
			librarySharp,
			archive,
			create,
			layers,
			// server,
			trash,
			checkAdmin,
			confirmYesNo,
			settings,
			showMsgInfo,
			showMsgWarning,
			showMsgError,
			getPlant,
			getPlants,
			getPrinter,
			getRawAddressees,
			getRawAlternativeAddressees,
			getRawCarriers,
			getRawEmployees,
			getRawItems,
			getRawSuppliers,
			getSettings,
			hasPrinter,
			searchLocation,
			searchLocations,
			searchProject,
			searchProjectRow,
			searchProjectRows,
			searchWarehouses,
			tablesData,
			updateUser,
		}),
		computed: {
			plantField() { return this.fields[this.field.plant] },
			warehouseField() { return this.fields[this.field.warehouse] },
			isDisposeAllowed() { return (this.settings.global.unrestrictedDispose || checkAdmin(this.tablesData.currentUser)) },
		},
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			await this.setDefault();
			await this.settingBaseData();
			if (this.isFromLogin == true) await this.getAllTablesData();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			async getUrlParamsAndQuery() {
				this.isFromLogin = (!!this.$route.params.id);
			},
			async setDefault() {
				this.updatingLibraries = true;
				this.spinnerText = this.defaultSpinnerText;
				this.fields.forEach(element => element.value = element.defaultValue);
				this.positionBarcode = null;
				this.packageBarcode = null;
				this.itemsLocationBarcode = null;
				this.plantAutoAssignment = true;
				this.updateUserWhenPlantChange = false;
				this.searchingData = false;
				this.updatingLibraries = false;
			},
			getPlaceHolder(element) {
				return ((this.settings.global.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : '')
			},
			executeLogOut() {
				this.tablesData.currentPlant = null;
				this.tablesData.currentWarehouse = null;
				this.$router.push('/login');
			},
			//Database
			async settingBaseData() {
				if (this.isFromLogin == true) {
					this.updatingLibraries = true;
					this.tablesData.currentPlant = null;
					this.tablesData.currentWarehouse = null;
					// this.spinnerText = this.checkPrintersText;
					await this.hasPrinter();
					this.spinnerText = this.loadingPlantsText;
					await this.settingDisposeWaitingDays();
					await this.getPlants();
					await this.settingPlant();
					await this.settingWarehouse();
					this.updatingLibraries = false;
				}
				else {
					this.plantField.value = this.tablesData.currentPlant;
					this.warehouseField.value = this.tablesData.currentWarehouse;
				}
			},
			async getAllTablesData() {
				this.updatingLibraries = true;
				this.spinnerText = this.loadingCarriersText;
				await this.getRawCarriers();
				this.spinnerText = this.loadingSuppliersText;
				await this.getRawSuppliers();
				this.spinnerText = this.loadingItemsText;
				await this.getRawItems();
				this.spinnerText = this.loadingAddresseesText;
				await this.getRawAddressees();
				this.spinnerText = this.loadingAlternativeAddresseesText;
				await this.getRawAlternativeAddressees();
				this.spinnerText = this.loadingEmployeesText;
				await this.getRawEmployees();
				this.updatingLibraries = false;
			},
			async settingDisposeWaitingDays() {
				const serverSettings = await this.getSettings();
				const days = parseInt(serverSettings?.schedules?.long_term_stocks_days, 10);
				const extraDays = parseInt(serverSettings?.schedules?.long_term_stocks_days_extra, 10);
				const myDisposeWaitingDays = days + extraDays;
				if (Number.isFinite(myDisposeWaitingDays) && myDisposeWaitingDays >= 0) {
					this.settings.global.disposeWaitingDays = myDisposeWaitingDays;
				}
			},
			async settingPlant() {
				if (this.plantAutoAssignment == true && this.tablesData.currentUser.plant) {
					await this.getPlant(this.tablesData.currentUser.plant.id);
					this.plantField.value = this.tablesData.currentPlant;
				} else {
					this.plantField.value = this.plantField.defaultValue;
				}
			},
			async settingWarehouse() {
				let confirmResult = null;
				if (this.tablesData.currentPlant) {
					// this.spinnerText = this.loadingWarehousesText;
					await this.searchWarehouses(this.tablesData.currentPlant.id);
					if (this.tablesData.warehouses.length == 1) {
						this.warehouseField.value = this.tablesData.warehouses[0];
						if (this.settings.home.lockPlantAndWarehouse == true) {
							await this.confirmYesNo(this.messageTitlePlantWarehouse, this.messageConfirm + this.tablesData.warehouses[0].name)
							.then((data) => { confirmResult = data; })
						} else {
							confirmResult = true;
						}
						if (confirmResult) {
							this.tablesData.currentWarehouse = this.tablesData.warehouses[0];
							// this.spinnerText = this.loadingLocationsText;
							await this.searchLocations(this.tablesData.currentWarehouse.id);
							await this.getEnabledPrinter();
						}
						else {
							this.detectUnselection(this.warehouseField);
						}
					} else {
						this.warehouseField.value = this.warehouseField.defaultValue;
					}
				} else {
					this.detectUnselection(this.warehouseField);
				}
			},
			prepareUpdateUser() {
				let myRecord = {
					user: {
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			async updateUserPlant() {
				if (this.updateUserWhenPlantChange == true) {
					await this.updateUser(this.tablesData.currentUser.id, this.prepareUpdateUser(), false)
				}
			},
			async positionSearch() {
				if (this.positionBarcode && this.positionBarcode.length>0) {
					this.tablesData.currentProjectRow = null;
					this.spinnerText = this.loadingProjectRowText;
					this.searchingData = true;
					await this.searchProjectRow(this.positionBarcode);
					this.searchingData = false;
					if (this.tablesData.currentProjectRow) {
						if (this.tablesData.currentProjectRow.project.receiving === true || this.tablesData.currentProjectRow.project.shipping === true) {
							if (this.tablesData.currentProjectRow.location) {
								this.showMsgInfo(this.searchTitle,this.foundPosition + "<br><br>" + this.tablesData.currentProjectRow.plant.name + "<br>" + (this.tablesData.currentProjectRow.warehouse ? this.tablesData.currentProjectRow.warehouse.name : "-") + "<br>" + this.tablesData.currentProjectRow.location.name )
							} else {
								// this.showMsgInfo(this.searchTitle,this.notFoundPosition)
								this.showMsgInfo(this.searchTitle,this.foundPosition + "<br><br>" + this.tablesData.currentProjectRow.plant.name + "<br>" + (this.tablesData.currentProjectRow.warehouse ? this.tablesData.currentProjectRow.warehouse.name : "-") + "<br>" + "-")
							}
						} else {
							this.showMsgWarning(this.searchTitle,this.invalidProjectMsg)
						}
					}
					else {
						this.showMsgWarning(this.searchTitle,this.notFoundPackageMsg)
					}
				}
				else {
					this.showMsgError(this.searchTitle,this.nullBarcode)
				}
			},
			async packageSearch() {
				if (this.packageBarcode && this.packageBarcode.length>0) {
					this.tablesData.currentProjectRow = null;
					this.spinnerText = this.loadingProjectRowText;
					this.searchingData = true;
					await this.searchProjectRow(this.packageBarcode);
					this.searchingData = false;
					if (this.tablesData.currentProjectRow) {
						if ((!this.tablesData.currentProjectRow.warehouse || this.tablesData.currentProjectRow.warehouse.id == this.tablesData.currentWarehouse.id ) && this.tablesData.currentProjectRow.plant.id == this.tablesData.currentPlant.id) {
							if (this.tablesData.currentProjectRow.project.receiving === true) {
								this.$router.push(`/finalize/receipt/`+this.tablesData.currentProjectRow.id);
							} else if (this.tablesData.currentProjectRow.project.shipping === true) {
								this.$router.push(`/finalize/shipment/`+this.tablesData.currentProjectRow.id);
							}
						}
						else {
							this.showMsgWarning(this.searchTitle,this.differentPlantOrWarehousetMsg)
						}
					}
					else {
						this.tablesData.currentProject = null;
						this.spinnerText = this.loadingProjectText;
						this.searchingData = true;
						await this.searchProject(this.packageBarcode);
						this.searchingData = false;
						if (this.tablesData.currentProject) {
							if ((!this.tablesData.currentProject.warehouse || this.tablesData.currentProject.warehouse.id == this.tablesData.currentWarehouse.id ) && (!this.tablesData.currentProject.plant || this.tablesData.currentProject.plant.id == this.tablesData.currentPlant.id )) {
								if (this.tablesData.currentProject.receiving === true || this.tablesData.currentProject.shipping === true) {
									if (!this.tablesData.currentProject.employee) this.$router.push(`/search/` + this.tablesData.currentProject.id + `?code=` + this.tablesData.currentProject.code);
									else this.$router.push(`/revision/multiple/` + this.tablesData.currentProject.id + `?code=` + this.tablesData.currentProject.code);
								} else {
									this.showMsgWarning(this.searchTitle,this.invalidProjectMsg)
								}
							}
							else {
								this.showMsgWarning(this.searchTitle,this.differentPlantOrWarehousetMsg)
							}
						}
						else {
							this.showMsgWarning(this.searchTitle,this.notFoundPackageMsg)
						}
					}
				}
				else {
					this.showMsgError(this.searchTitle,this.nullBarcode)
				}
			},
			async itemsLocationSearch() {
				if (this.itemsLocationBarcode && this.itemsLocationBarcode.length>0) {
					this.tablesData.currentLocation = null;
					this.spinnerText = this.loadingLocationText;
					this.searchingData = true;
					await this.searchLocation(null, this.itemsLocationBarcode);
					this.searchingData = false;
					if (this.tablesData.currentLocation) {
						if (this.tablesData.currentLocation.warehouse_id == this.tablesData.currentWarehouse.id) {
							this.tablesData.projectRows = [];
							this.spinnerText = this.loadingProjectRowsText;
							this.searchingData = true;
							await this.searchProjectRows(null, this.itemsLocationBarcode, false);
							this.searchingData = false;
							if (this.tablesData.projectRows.length > 0) {
								this.$router.push(`/revision/location/` + this.tablesData.currentLocation.id);
							}
							else {
								this.showMsgWarning(this.searchTitle,this.notFoundLocationMsg)
							}
						}
						else {
							this.showMsgWarning(this.searchTitle,this.differentWarehousetMsg)
						}
					} else {
						this.showMsgWarning(this.searchTitle,this.notFoundLocation)
					}
				}
				else {
					this.showMsgError(this.searchTitle,this.nullBarcode)
				}
			},
			//Actions
			async detectSelection(field, value) {
				field.value = value;
				let confirmResult = null;
				switch (field.id) {
					case this.field.plant:
						this.tablesData.currentPlant = value;
						await this.updateUserPlant();
						// this.spinnerText = this.loadingWarehousesText;
						await this.searchWarehouses(this.tablesData.currentPlant.id);
						if (this.tablesData.warehouses.length == 1) {
							this.warehouseField.value = this.tablesData.warehouses[0];
							if (this.settings.home.lockPlantAndWarehouse == true) {
								await this.confirmYesNo(this.messageTitlePlantWarehouse, this.messageConfirm + this.tablesData.warehouses[0].name)
								.then((data) => { confirmResult = data; })
							} else {
								confirmResult = true;
							}
							if (confirmResult) {
								this.tablesData.currentWarehouse = this.tablesData.warehouses[0];
								// this.spinnerText = this.loadingLocationsText;
								await this.searchLocations(this.tablesData.currentWarehouse.id);
								await this.getEnabledPrinter();
							}
							else {
								this.detectUnselection(this.warehouseField);
							}
						} else if (this.tablesData.warehouses.length > 1) {
							this.tablesData.currentWarehouse = this.tablesData.warehouses[0];
							this.warehouseField.value = this.tablesData.currentWarehouse;
							this.detectUnselection(this.warehouseField);
						}
						else {
							this.tablesData.warehouses = [];
							this.tablesData.currentWarehouse = null;
							this.detectUnselection(this.warehouseField);
						}
						break;
					case this.field.warehouse:
						if (this.settings.home.lockPlantAndWarehouse == true) {
							await this.confirmYesNo(this.messageTitlePlantWarehouse, this.messageConfirm + value.name)
							.then((data) => { confirmResult = data; })
						} else {
							confirmResult = true;
						}
						if (confirmResult) {
							this.tablesData.currentWarehouse = value;
							// this.spinnerText = this.loadingLocationsText;
							await this.searchLocations(this.tablesData.currentWarehouse.id);
							await this.getEnabledPrinter();
						}
						else {
							this.detectUnselection(this.warehouseField);
						}
						break;
				}
			},
			detectUnselection(field) {
				field.value = field.defaultValue;
				switch (field.id) {
					case this.field.plant:
						this.tablesData.currentPlant = this.plantField.defaultValue;
						this.tablesData.currentWarehouse = this.warehouseField.defaultValue;
						this.plantField.value = this.plantField.defaultValue;
						this.warehouseField.value = this.warehouseField.defaultValue;
						break;
					case this.field.warehouse:
						this.tablesData.currentWarehouse = this.warehouseField.defaultValue;
						this.warehouseField.value = this.warehouseField.defaultValue;
						break;
				}
			},
			async getEnabledPrinter() {
				// this.spinnerText = this.loadingEnabledPrinterText;
				this.tablesData.currentPrinter = null;
				if (this.settings.global.printerManagement) {
					if (this.tablesData.currentWarehouse && this.tablesData.currentWarehouse.printers.length > 0 ) {
						await this.getPrinter(this.tablesData.currentWarehouse.printers[0].id);
					}
					else {
						this.showMsgWarning(this.messageTitlePrint, this.warningPrintNotFound);
					}
				}
			},
			async onScan(barcode) {
				if(this.isActive == true) {
					switch (document.activeElement.name) {
						case 'bPosition':
							this.positionBarcode = barcode
							await this.positionSearch()
							break;
						case 'bPackage':
							this.packageBarcode = barcode;
							await this.packageSearch()
							break;
						case 'bItemsLocation':
							this.itemsLocationBarcode = barcode;
							await this.itemsLocationSearch()
							break;
						default:
							this.showMsgWarning(this.searchTitle,this.unselectedChoice)
					}
				}
			},
		},
	});
</script>
